import { render, staticRenderFns } from "./DepartmentModal.vue?vue&type=template&id=7c995b23&scoped=true&"
import script from "./DepartmentModal.vue?vue&type=script&lang=js&"
export * from "./DepartmentModal.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentModal.vue?vue&type=style&index=0&id=7c995b23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c995b23",
  null
  
)

export default component.exports